"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _Account = _interopRequireDefault(require("./components/Account"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "Profile",
  components: {
    Account: _Account.default
  },
  data: function data() {
    return {
      user: {},
      activeTab: "account"
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(["name", "username"])),
  methods: {}
};